export default "__VITE_ASSET__BcrkId3M__"